import React from "react";

// react router
import { Link } from "react-router-dom";

import {
    FeelGoodFindContainer,
    Header,
    Data,
    FeelGoodFindInner,
    LinkOuter,
    ImageDetail,
} from "../../styles/FeelGoodFind";

// images
import accessoriesImg from "assets/images/feels-good/accessories.jpg";
import candlesImg from "assets/images/feels-good/candles.jpg";
import sesonalImg from "assets/images/feels-good/sesonal.jpg";
import wallArtImg from "assets/images/feels-good/wall-art.jpg";

function FeelGoodFind(props) {
    return (
        <FeelGoodFindContainer>
            <div className="container">
                <Header>feel good finds</Header>
                <Data className="row">
                    {/* item */}
                    <FeelGoodFindInner className="col-6 col-md-3">
                        <LinkOuter>
                            <Link
                                to="/shop/accessories?id=33"
                                className="text-decoration-none"
                            >
                                <img
                                    src={accessoriesImg}
                                    className="img-fluid w-100"
                                    alt="img"
                                />
                                <ImageDetail>accessories</ImageDetail>
                            </Link>
                        </LinkOuter>
                    </FeelGoodFindInner>

                    {/* item */}
                    <FeelGoodFindInner className="col-6 col-md-3">
                        <LinkOuter>
                            <Link
                                to="/shop/wall-decor?id=15"
                                className="text-decoration-none"
                            >
                                <img
                                    src={candlesImg}
                                    className="img-fluid w-100"
                                    alt="img"
                                />
                                <ImageDetail>wall art</ImageDetail>
                            </Link>
                        </LinkOuter>
                    </FeelGoodFindInner>

                    {/* item */}
                    <FeelGoodFindInner className="col-6 col-md-3">
                        <LinkOuter>
                            <Link
                                to="/category/seasonal?id=42"
                                className="text-decoration-none"
                            >
                                <img
                                    src={sesonalImg}
                                    className="img-fluid w-100"
                                    alt="img"
                                />
                                <ImageDetail>seasonal</ImageDetail>
                            </Link>
                        </LinkOuter>
                    </FeelGoodFindInner>

                    {/* item */}
                    <FeelGoodFindInner className="col-6 col-md-3">
                        <LinkOuter>
                            <Link
                                to="/shop/candelabras-candlesticks?id=2"
                                className="text-decoration-none"
                            >
                                <img
                                    src={candlesImg}
                                    className="img-fluid w-100"
                                    alt="img"
                                />
                                <ImageDetail>
                                    candles and candleholders
                                </ImageDetail>
                            </Link>
                        </LinkOuter>
                    </FeelGoodFindInner>
                </Data>
            </div>
        </FeelGoodFindContainer>
    );
}

export default FeelGoodFind;
